import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import paystackService from "services/paystack";

/** Initial state */
const initialState = {};

export const initializeTransactionAsync = createAsyncThunk(
  "paystack/initializeTransaction",
  async ({ data }, thunkAPI) => {
    try {
      const res = await paystackService.initializeTransaction(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const verifyTransactionAsync = createAsyncThunk(
  "paystack/verifyTransaction",
  async ({ reference, data = {} }, thunkAPI) => {
    try {
      const res = await paystackService.verifyTransaction(reference, data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const chargeSavedCardAsync = createAsyncThunk(
  "paystack/chargeSavedCard",
  async ({ data = {} }, thunkAPI) => {
    try {
      const res = await paystackService.chargeSavedCard(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const paystackSlice = createSlice({
  name: "paystack",
  initialState,
  reducers: {},
  extraReducers: {},
});

export const {} = paystackSlice.actions;
export default paystackSlice.reducer;
